import {
  expensesTransactionsRouteProps,
  orgExpenseReportRouteProps,
} from 'src/navigation/routeProps'
import CreditCardsFullPaginatedDataReducer, {
  Actions as CreditCardsFullPaginatedDataActions,
  CreditCardsFullPaginatedDataState,
  initialState as initialCreditCardsFullPaginatedDataState,
} from 'src/redux/creditCardsFullPaginatedData.reducer'
import { createBackgroundReducer } from 'src/redux/genericReducers'
import UsersFullPaginatedDataReducer, {
  Actions as UsersFullPaginatedDataActions,
  initialState as initialUsersFullPaginatedDataState,
  UsersFullPaginatedDataState,
} from 'src/redux/usersFullPaginatedData.reducer'

export type TransactionsAllTransactionsState = {
  creditCardsFullPaginatedData: CreditCardsFullPaginatedDataState
  usersFullPaginatedData: UsersFullPaginatedDataState
}

export const initialState: TransactionsAllTransactionsState = {
  creditCardsFullPaginatedData: initialCreditCardsFullPaginatedDataState,
  usersFullPaginatedData: initialUsersFullPaginatedDataState,
}

export type Actions =
  | CreditCardsFullPaginatedDataActions
  | UsersFullPaginatedDataActions

const CoreTransactionsAllTransactionsReducer = (
  state = initialState,
  action: Actions,
): TransactionsAllTransactionsState => ({
  creditCardsFullPaginatedData: CreditCardsFullPaginatedDataReducer(
    state.creditCardsFullPaginatedData,
    action as CreditCardsFullPaginatedDataActions,
  ),
  usersFullPaginatedData: UsersFullPaginatedDataReducer(
    state.usersFullPaginatedData,
    action as UsersFullPaginatedDataActions,
  ),
})

const TransactionsAllTransactionsReducer = createBackgroundReducer(
  [expensesTransactionsRouteProps, orgExpenseReportRouteProps],
  initialState,
  CoreTransactionsAllTransactionsReducer,
)

export default TransactionsAllTransactionsReducer
